import Vue from 'vue'
import VueRouter from 'vue-router'
import ReisekostenRechner from "@/views/ReisekostenRechner";
import PrintPage from "@/views/PrintPage";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'reisekostenrechner',
    component: ReisekostenRechner
  },
  {
    path: '/print',
    name: 'printPage',
    component: PrintPage
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
